import { useStoredViewMode, VIEW_MODE } from '@/shared/hooks';

const VIEW_MODE_STORAGE_KEY = 'reels-creator-sessions:view-mode';

export const useReelSessionViewMode = () =>
  useStoredViewMode(VIEW_MODE_STORAGE_KEY, VIEW_MODE.cards);
